import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=5927d56b&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927d56b",
  null
  
)

component.options.__file = "LoginPage.vue"
export default component.exports